import React from 'react'
import '../styling/exp.css'
const  Exp = () => {
  return (
    <div className='exp'>
      <div className="achieve">
        <div className="circle">1+</div>
        <span>Years</span>
        <span>Experience</span>
      </div>
      <div className="achieve">
        <div className="circle">3+</div>
        <span>Years</span>
        <span>Completed</span>
      </div>
      <div className="achieve">
        <div className="circle">2+</div>
        <span>Companies</span>
        <span>Worked</span>
      </div>
    </div>
  )
}

export default Exp
